export default __webpack_public_path__ + "static/1439-b943c91b1fbe62c5d5d28cee506bbe23.gif";